import { useContext } from "react";

import supportContext from "./context";

const useSupport = () => useContext(supportContext);

export default useSupport;
